import React, { Component } from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Context} from './context.js';
import './App.css';


class App extends Component {
  render() {

    return (
      <MuiThemeProvider>
        <BrowserRouter>
          <div className="App" id="app">
            <Route component={Context} />
          </div>
        </BrowserRouter>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js